const TeamDetailsTypes = {
    GET_TEAM_DETAILS_START:'GET_TEAM_DETAILS_START',
    GET_TEAM_DETAILS_SUCCESS:'GET_TEAM_DETAILS_SUCCESS',
    GET_TEAM_DETAILS_FAILED:'GET_TEAM_DETAILS_FAILED',
    SET_TEAM_ACTIVE_TAB:'SET_TEAM_ACTIVE_TAB'
}

export default TeamDetailsTypes